var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getLayout)?_c(_vm.getLayout,{tag:"component",style:(_vm.getFont)}):_c('div',[[_c('keep-alive',{attrs:{"max":5}},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }